import React from 'react';

import { TipCardDiv } from './TipCard.style';

const TipCard: React.FC<{
  index: number;
  tip: string;
  numTips: number;
  onClick: () => void;
}> = ({ index, tip, numTips, onClick }) => {
  return (
    <TipCardDiv onClick={onClick}>
      <h2>{tip}</h2>
      <p>{`${index + 1} / ${numTips}`}</p>
    </TipCardDiv>
  );
};

export default TipCard;
